import {Component, Input, OnInit} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {WidgetAdUnitStatusChangeSettingsDialogComponent} from './widget-ad-unit-status-change-settings-dialog.component';
import {AdStatsAlertsService} from '../../../../../shared/services/ad-stats-alerts.service';
import {StatusChangeLine} from '../../../domain/alerts/status-change-line.model';
import {StatusRequest} from '../../../domain/alerts/status-request.model';
import {StatusChange} from '../../../domain/alerts/status-change.enum';

@Component({
  selector: 'cm-widget-ad-unit-status-change',
  template: `
    <cm-widget>
      <cm-widget-title>
        Status change
        <i class="fas fa-cog" aria-hidden="true" (click)="openSettings()"></i>
      </cm-widget-title>
      <cm-widget-actions>
        <cm-widget-actions>
          <cm-publisher-multiselect-search-dropdown
            [selectedPublisherIds]="settings?.filter.publisherIds"
            (selectionIdsChange)="settings?.filter.publisherIds = $event; refreshData()"></cm-publisher-multiselect-search-dropdown>
        </cm-widget-actions>
      </cm-widget-actions>
      <cm-widget-content>
        <p *ngIf="noData" [hidden]="loading" class="card-message">No data available for chosen settings</p>
        <div *ngIf="loading" class="card-message">
          <mat-spinner [color]="'primary'" [mode]="'indeterminate'" [diameter]="'30'"></mat-spinner>
        </div>
        <p *ngIf="!settings" class="card-message">
          <i class="fas fa-cog" aria-hidden="true"></i>
          <span>Please choose widget settings</span>
        </p>
        <cm-ad-unit-status-change-table #table [hidden]="loading || noData" [paginator]="paginator" [data]="data"></cm-ad-unit-status-change-table>
      </cm-widget-content>
      <cm-widget-footer>
        <mat-paginator #paginator
                       [hidden]="loading || noData"
                       [pageSize]="10"
                       [pageSizeOptions]="[5, 10, 20]">
        </mat-paginator>
      </cm-widget-footer>
    </cm-widget>
  `,
})
export class WidgetAdUnitStatusChangeComponent implements OnInit {

  @Input()
  loading = false;

  data: StatusChangeLine[] = [];
  noData = false;

  public settings: StatusRequest;

  constructor(private matDialog: MatDialog,
              private service: AdStatsAlertsService) {
    this.settings = new StatusRequest();
    this.settings.statusChanges[StatusChange.READY_TO_ACTIVE] = 10;
  }

  ngOnInit(): void {
    this.refreshData();
  }

  refreshData() {
    if (!this.settings) {
      return;
    }
    this.loading = true;
    this.service.statusChanges(this.settings).subscribe(next => {
        this.data = next;
        this.noData = !next || !next.length;
        this.loading = false;
      },
      () => {
        this.loading = false;
      });
  }

  openSettings() {
    this.matDialog.open(WidgetAdUnitStatusChangeSettingsDialogComponent, <MatDialogConfig>{
      data: {
        settings: this.settings
      },
      width: '600px'
    }).afterClosed().subscribe(result => {
      if (result) {
        this.settings = result;
        this.refreshData();
      }
    });
  }

}

